<template>

  <div id="about">

    <div class="container">
      <div class="row">

        <div class="col-md-6">
          <div class="title">
            O que <span>fazemos</span>
          </div>
          <div class="description">
            <p>
              Conectamos Organizações Sociais, Varejo e Pessoas através de ferramentas de Marketing
              Relacionado à Causa e geramos valor por meio da ampliação do conceito de doação.
              Queremos que o ato de doar seja incorporado ao dia a dia das pessoas e naquilo que elas já
              fazem.
            </p> 
            <p>
              Ao comprar um produto com desconto em uma empresa afiliada, você estará ajudando uma
              Organização Social.
              <ul>
                <li>Para ONGs: arrecadação, divulgação, comunicação</li>
                <li>Para Varejo: aumento de vendas, marketing relacionado à causa, valorização da marca</li>
                <li>Para Pessoas: descontos, facilidade, segurança</li>
              </ul>
            </p>
            <p>
              <i>“Acreditamos que a tecnologia pode mudar o mundo e ser um agente transformador de vidas.”</i>
            </p>
          </div>
          
        </div>
        <div class="col-md-6">
          <img class="about-image" :src="about"/>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import about from '../../assets/images/oquefazemos.png';

export default{
  data(){
    return {
      about: about,
    }
  }
}
</script>

<style scoped lang="scss">
#about{
  background-color: #fff;

  .title{
    margin-top: 40px;
    font-size: 28px;
    font-family: RalewayRegular;

    span{
      color: #00AE39;
    }
  }

  .description{
    font-family: RalewayRegular;
    margin-top: 20px;

    i{
      color: #00AE39;
    }
  }

  .button{
    margin-top: 20px;
    padding-bottom: 20px;

    a{
      font-family: RalewayRegular;
      display: block;
      width: 220px;
      padding: 10px;
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      text-align: center;
      border-radius: 40px;
      text-decoration: none;
    }
  }

  .about-image{
    display: block;
    margin: 0 auto;
    padding: 20px;
    width: 100%;
  }

  .gallery{
    // background-image: url("../../assets/images/home-about-gallery-bkg.png");
    // background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 400px;
    margin-top: 30px;
    margin-bottom: 20px;
    margin-left: 20px;
    margin-right: 20px;
    display: block;
    
    .image{
      width: 220px;
      height: auto;
      position: absolute;

      img{
        width: 100%;
        height: auto;
        display: block;
        padding: 8px;
        border-radius: 12px;
      }

      &.image-left{
        left: 0;
        top: 80px;
      }

      &.image-right{
        right: 0;
        top: 80px;
      }

      &.image-center{
        border: 8px solid #e1e1e1;
        border-radius: 10px;
        top: 200px;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        img{
          padding: 0px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/AboutSection.vue